export default __webpack_public_path__ + "static/13-a2e8b659f74fda6e10c8fe1501ef7cbb.jpg";